import { Box, Divider, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

const StrongDivider = withStyles({
  root: {
    backgroundColor: "#2A313B",
  },
})(Divider);

const ROIEquation = () => (
  <Box textAlign="center">
    <Typography component="div" style={{ fontSize: "13px" }}>
      (Royalties Received + Sale Proceeds - Purchased Price)
    </Typography>
    <Box my={1}>
      <StrongDivider />
    </Box>
    <Typography component="div" style={{ fontSize: "13px" }}>
      Purchased Price
    </Typography>
  </Box>
);

export default ROIEquation;
